export const getterTypes = {
  account: (state) => {
    return state.account
  }
}
